import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/GPOVALLAS/templates`;
const THUMBS = `${BASE}/auto-resolution/thumbnails`;
const PREVIEWS = `${BASE}/previews/auto-resolution`;

export const GPOVALLASAutoResolution = defineTemplate({
  mode: 'legacy',
  id: 'auto-resolution',
  clientId: 'GPOVALLAS',
  handlerKey: 'GPOVALLAS',
  title: 'Auto resolution',
  thumbnail: {
    url: `${THUMBS}/auto-resolution_300x600.png`,
    optimizedUrl: `${THUMBS}/optimized/auto-resolution_300x600.png`,

    aspectRatio: 'vertical'
  },
  previewByResolution: {
    '1920x1080': { kind: 'video', url: `${PREVIEWS}/auto-resolution_1920x1080.mp4` },
    '1080x1920': { kind: 'video', url: `${PREVIEWS}/auto-resolution_1080x1920.mp4` },
    '1080x1350': { kind: 'video', url: `${PREVIEWS}/auto-resolution_1080x1350.mp4` },
    '1080x1080': { kind: 'video', url: `${PREVIEWS}/auto-resolution_1080x1080.mp4` },
    '300x250': { kind: 'video', url: `${PREVIEWS}/auto-resolution_300x250.mp4` },
    '300x600': { kind: 'video', url: `${PREVIEWS}/auto-resolution_300x600.mp4` },
    '310x482': { kind: 'video', url: `${PREVIEWS}/auto-resolution_310x482.mp4` },
    '400x600': { kind: 'video', url: `${PREVIEWS}/auto-resolution_400x600.mp4` }
  },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'videoLink',
      label: 'Video',
      type: 'video',
      placeholder: 'https://cdn.filestackcontent.com/...',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/available-now/video.png'
    },
    { key: 'enableSubtitles', label: 'Subtítulos', type: 'switch', required: true, defaultValue: false }
  ],
  promptTemplate:
    `Creá todas las "resoluciones" para "${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/GPOVALLAS/examples/test.mp4"`
});
